<template>
  <nuxt-link
    :to="link"
    class="text-center font-bold inline-block rounded uppercase border-transparent border-b-2 rounded-b-none hover:border-blue-200 py-1"
    :class="[textColorClass]"
    :exact="exact"
    :append="append"
  >
    <div v-if="hasSlotData">
      <slot />
    </div>
    <div v-else>
      {{ label || link }}
    </div>
  </nuxt-link>
</template>

<script>
export default {
  props: {
    // required
    link: {
      type: String,
      required: true
    },
    // optional
    append: {
      type: Boolean,
      required: false,
      default: false
    },
    exact: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    textColorClass: {
      type: String,
      required: false,
      default: 'text-blue-800'
    }
  },
  computed: {
    hasSlotData() {
      return this.$slots.default
    }
  }
}
</script>

<style lang="postcss" scoped>
.nuxt-link-active {
  @apply border-blue-800;
}
</style>
